import React from "react"
import { Box, Typography } from "@mui/material";
import Content from "../../components/Content";


const ContainerHoneycomb = ({ container }) => {
  const childSize = 120; // The width and height of the child components
  const spacing = 20;    // Spacing between layers

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
        minHeight: '450px',
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 4, color: 'text.primary', fontWeight: 'bold' }}>
        {container.text}
      </Typography>
      <Box sx={{ position: 'relative', width: 800, height: 450 }}>
        {container.children.map((child, index) => {
          // The first child (index 0) is the center element.
          if (index === 0) {
            return (
              <Box
                key={child.id}
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              >
                <Content child={child} />
              </Box>
            );
          }
          
          let layer = 1;
          let childrenInPreviousLayers = 1;
          
          // Determine which layer the child belongs to
          // Layer 1 has 6 children, Layer 2 has 12, etc.
          while (index >= childrenInPreviousLayers + layer * 6) {
            childrenInPreviousLayers += layer * 6;
            layer++;
          }
          
          const totalChildrenInLayer = layer * 6;
          const indexInLayer = index - childrenInPreviousLayers;

          // Calculate the radius based on the layer and spacing
          const radius = (childSize / 2 + spacing) * (layer * 2);

          // Calculate the angle based on the layer and its rotation
          const baseAngle = (360 / totalChildrenInLayer) * indexInLayer;
          // Every layer is rotated by 30 degrees to fit in the gaps of the previous layer
          const rotationOffset = 30 * (layer ) + (layer % 2 ? -180 : - 60) ; 
          
          const angle = baseAngle + rotationOffset;
          const angleInRadians = angle * (Math.PI / 180);

          // Calculate the x and y offsets using trigonometry
          const xOffset = radius * Math.cos(angleInRadians);
          const yOffset = radius * Math.sin(angleInRadians);
          
          return (
            <Box
              key={child.id}
              sx={{
                position: 'absolute',
                top: `calc(50% + ${yOffset}px)`,
                left: `calc(50% + ${xOffset}px)`,
                transform: 'translate(-50%, -50%)',
              }}
            >
              <Content child={child} />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default ContainerHoneycomb
